export default {"src":"/_next/static/media/SEDG.ce9e7592.svg","height":18,"width":18};